import metadata from "./../../block.json";
import Save from "./../../Save";

const v1 = {
	attributes: {
		...metadata.attributes,
		enableSubHeading: {
			type: "boolean",
			default: true,
		},
		subHeadingTypography: {
			type: "object",
			default: {
				typography: 1,
				weight: 400,
			},
			style: [
				{
					selector: "{{WRAPPER}} .mzb-sub-heading p",
				},
			],
		},
		headingLayout1AdvancedStyle: {
			type: "string",
			default: "heading-layout-1-style-1",
		},
		typography: {
			type: "object",
			default: {
				typography: 1,
				weight: 500,
			},
			style: [
				{
					selector:
						"{{WRAPPER}} .mzb-post-heading .mzb-heading-text, {{WRAPPER}} .mzb-heading-inner .mzb-heading-text",
				},
			],
		},
	},
	supports: metadata.supports,
	save: Save,
};

export default v1;
